import {
  Button,
  FormControl,
  InputAdornment,
  MenuItem,
  Select,
} from "@material-ui/core";
import CustomTextField from "./customTextField";
import StatusSelect from "components/Select/StatusSelect";
import FromToDatePicker from "./fromAndToDate";
import SearchIcon from "@material-ui/icons/Search";
import ExcelImage from "images/excelimg.png";

import Input from "@material-ui/core/Input";
import ListItemText from "@material-ui/core/ListItemText";
import InputLabel from "@material-ui/core/InputLabel";
import { Autocomplete } from "@material-ui/lab";
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },

  getContentAnchorEl: null,
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "center",
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "center",
  },
  variant: "menu",
};
const statusArr = [
  {
    label: "All",
    value: "All",
  },
  {
    label: "Active",
    value: "1",
  },
  {
    label: "Inactive",
    value: "0",
  },
];
const TopHeaderBar = (props) => {
  const {
    fromDate,
    toDate,
    CurrentStatus,
    onSearch,
    searchVal,
    OnStatusValueChange,
    onDatePickerValueChange,
    onClearFilters,
    addBtnName,
    OnAddbtnClick,
    onExport,
    EntityList,
    CurrentEntity,
    OnEntityValueChange,
    CurrentPartner,
    PartnerList,
    OnPartnerValueChange
  } = props;
  let vStatues = [0, 1, "All"].includes(CurrentStatus)
    ? CurrentStatus
    : "All";

  const handleChange = (event) => {
    if (event.target.value !== "Status") {
      console.log("ETV", event.target.value, "CurrentStatus", CurrentStatus);
      OnStatusValueChange(event.target.value);
    }
  };
  return (
    <div>
      <div className="row" style={{ marginBottom: "10px" }}>
        <div className="col-2">
          <CustomTextField
            style={{ backgroundColor: "white", marginTop: "5px" }}
            placeholder="Search"
            variant="outlined"
            size="small"
            onChange={onSearch}
            value={searchVal}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
        </div>
        <div className="col-3">

          {OnStatusValueChange && (
            <FormControl style={{ width: "100%" }}>
              <InputLabel
                id="demo-mutiple-checkbox-label"
                style={{
                  fontFamily: "GT-Walsheim-medium",
                  fontSize: "18px",
                  color: "black",
                  fontWeight: "bold",
                  marginTop: "-5px",
                }}
              >
                {"Status"}
              </InputLabel>

              <Select
                value={vStatues}
                onChange={(event) => {
                  if (event.target.value !== "Status") {
                    console.log(
                      "ETV",
                      event.target.value,
                      "CurrentStatus",
                      CurrentStatus
                    );
                    OnStatusValueChange(event.target.value);
                  }
                }}
                labelId="demo-mutiple-checkbox-label"
                id="demo-mutiple-checkbox"
                input={<Input />}
                MenuProps={MenuProps}
              >
                <MenuItem value={"All"}>All</MenuItem>
                <MenuItem value={1}>Active</MenuItem>
                <MenuItem value={0}>Inactive</MenuItem>
              </Select>
            </FormControl>
          )}
          <div className="row">
            <div className="col-6">
              {OnEntityValueChange && Array.isArray(EntityList) && (
                <FormControl style={{ width: "100%" }}>
                  <InputLabel
                    id="demo-mutiple-checkbox-label"
                    style={{
                      fontFamily: "GT-Walsheim-medium",
                      fontSize: "18px",
                      color: "black",
                      fontWeight: "bold",
                      marginTop: "-5px",
                    }}
                  >
                    {"Entity"}
                  </InputLabel>
                   
                  <Select
                    value={CurrentEntity}
                    onChange={(event) => {
                      OnEntityValueChange(event.target.value);
                    }}
                    labelId="demo-mutiple-checkbox-label"
                    id="demo-mutiple-checkbox"
                    input={<Input />}
                    MenuProps={MenuProps}
                  >
                    {EntityList.map((item) => {
                      return <MenuItem value={item.value}>{item.label}</MenuItem>
                    })}
                  </Select>
                </FormControl>
              )}
            </div>
            <div className="col-6">
              {OnPartnerValueChange && Array.isArray(PartnerList) && (
                <FormControl style={{ width: "100%" }}>
                  <InputLabel
                    id="demo-mutiple-checkbox-label"
                    style={{
                      fontFamily: "GT-Walsheim-medium",
                      fontSize: "18px",
                      color: "black",
                      fontWeight: "bold",
                      marginTop: "-5px",
                    }}
                  >
                    {"Partner"}
                  </InputLabel>

                  <Select
                    value={CurrentPartner}
                    onChange={(event) => {
                      OnPartnerValueChange(event.target.value);
                    }}
                    labelId="demo-mutiple-checkbox-label"
                    id="demo-mutiple-checkbox"
                    input={<Input />}
                    MenuProps={MenuProps}
                  >
                    {console.log("PartnerListMy",PartnerList)}
                    {PartnerList.map((item) => {
                      return <MenuItem value={item.id}>{item.name}</MenuItem>
                    })}
                  </Select>
                </FormControl>
              )}
            </div>
          </div>


        </div>


        <div className="col-4">
          {onDatePickerValueChange && <FromToDatePicker
            fromDate={fromDate}
            toDate={toDate}
            onChange={onDatePickerValueChange}
          />}
        </div>
        <div
          className="col-3"
          style={{
            justifyContent: "space-around",
            display: "flex",
            alignItems: "self-end",
          }}
        >
          <Button
            style={{
              backgroundColor: "#4f2d7f",
              fontSize: "11px",
              color: "#ffffff",
              marginRight: "5px",
              marginBottom: "10px",
            }}
            onClick={onClearFilters}
          >
            Clear Filters
          </Button>
          {OnAddbtnClick && (
            <Button
              style={{
                backgroundColor: "#4f2d7f",
                fontSize: "11px",
                color: "#ffffff",
                marginRight: "5px",
                marginBottom: "10px",
              }}
              onClick={OnAddbtnClick}
            >
              {addBtnName}
            </Button>
          )}
          <Button
            style={{
              backgroundColor: "#4f2d7f",
              fontSize: "11px",
              color: "#ffffff",
              marginRight: "5px",
              marginBottom: "10px",
            }}
            onClick={onExport}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 50 50"
              width="20"
              height="20"
              style={{ marginRight: "5px" }}
            >
              <rect width="100%" height="100%" fill="#008000" />
              <path
                fill="#ffffff"
                d="M28.875 0C28.855469 0.0078125 28.832031 0.0195313 28.8125 0.03125L0.8125 5.34375C0.335938 5.433594 -0.0078125 5.855469 0 6.34375L0 43.65625C-0.0078125 44.144531 0.335938 44.566406 0.8125 44.65625L28.8125 49.96875C29.101563 50.023438 29.402344 49.949219 29.632813 49.761719C29.859375 49.574219 29.996094 49.296875 30 49L30 44L47 44C48.09375 44 49 43.09375 49 42L49 8C49 6.90625 48.09375 6 47 6L30 6L30 1C30.003906 0.710938 29.878906 0.4375 29.664063 0.246094C29.449219 0.0546875 29.160156 -0.0351563 28.875 0ZM28 2.1875L28 6.53125C27.867188 6.808594 27.867188 7.128906 28 7.40625L28 42.8125C27.972656 42.945313 27.972656 43.085938 28 43.21875L28 47.8125L2 42.84375L2 7.15625ZM30 8L47 8L47 42L30 42L30 37L34 37L34 35L30 35L30 29L34 29L34 27L30 27L30 22L34 22L34 20L30 20L30 15L34 15L34 13L30 13ZM36 13L36 15L44 15L44 13ZM6.6875 15.6875L12.15625 25.03125L6.1875 34.375L11.1875 34.375L14.4375 28.34375C14.664063 27.761719 14.8125 27.316406 14.875 27.03125L14.90625 27.03125C15.035156 27.640625 15.160156 28.054688 15.28125 28.28125L18.53125 34.375L23.5 34.375L17.75 24.9375L23.34375 15.6875L18.65625 15.6875L15.6875 21.21875C15.402344 21.941406 15.199219 22.511719 15.09375 22.875L15.0625 22.875C14.898438 22.265625 14.710938 21.722656 14.5 21.28125L11.8125 15.6875ZM36 20L36 22L44 22L44 20ZM36 27L36 29L44 29L44 27ZM36 35L36 37L44 37L44 35Z"
              />
            </svg>
            Export
          </Button>
        </div>
      </div>
    </div>
  );
};

export default TopHeaderBar;
